import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "FormItem" }
const _hoisted_2 = { class: "FormItem__item" }

import { computed, PropType } from "vue";
import FormInput from "@/components/ds/form/items/FormInput.vue";
import FormCheckbox from "@/components/ds/form/items/FormCheckbox.vue";
import FormSelect from "@/components/ds/form/items/FormSelect.vue";
import FormTextarea from "@/components/ds/form/items/FormTextarea.vue";
import FormColor from "@/components/ds/form/items/FormColor.vue";
import FormImage from "@/components/ds/form/items/FormImage.vue";
import FormHtml from "@/components/ds/form/items/FormHtml.vue";
import { FormValue } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormItem',
  props: {
    item: {
        type: Object,
        required: true,
    },
    value: {
        type: Object as PropType<FormValue>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const components = {
    FormInput,
    FormCheckbox,
    FormSelect,
    FormTextarea,
    FormColor,
    FormImage,
    FormHtml,
};

const component = computed(() => {
    switch (props.item.type) {
        case "checkbox":
            return components.FormCheckbox;
        case "select":
            return components.FormSelect;
        case "text":
        case "number":
            return components.FormInput;
        case "textarea":
            return components.FormTextarea;
        case "color":
            return components.FormColor;
        case "image":
            return components.FormImage;
        case "html":
            return components.FormHtml;
        default:
            return "FormInput";
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), {
        item: __props.item,
        value: __props.value
      }, null, 8, ["item", "value"]))
    ]),
    _createElementVNode("label", null, _toDisplayString(__props.item.label), 1)
  ]))
}
}

})